import React from 'react';
import SvgIcon from './SvgIcon';

const EyeFull = props => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M12 5.438C5.55 5.438.937 12 .937 12S5.55 18.563 12 18.563 23.063 12 23.063 12 18.45 5.437 12 5.437z"
                stroke="currentColor"
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 15.563a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5zM10.688 11.063A1.5 1.5 0 0012 13.313"
                stroke="currentColor"
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};

EyeFull.displayName = 'EyeFullIcon';

export default EyeFull;
